import React from "react"
import { Form, Row, Col, FormGroup, Label, Input, Button } from "reactstrap"
import { useNavigate } from "react-router-dom"

const ColdCallForm = ({ formData, setFormData, onSubmit }) => {
  const navigate = useNavigate()

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <Form>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label>Name *</Label>
            <Input
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="rounded-4"
            />
          </FormGroup>
        </Col>

        <Col md={4}>
          <FormGroup>
            <Label>Email *</Label>
            <Input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              className="rounded-4"
            />
          </FormGroup>
        </Col>

        <Col md={4}>
          <FormGroup>
            <Label>Country *</Label>
            <Input
              name="country"
              value={formData.country}
              onChange={handleChange}
              className="rounded-4"
            />
          </FormGroup>
        </Col>
      </Row>

      <div className="mt-4">
        <Button color="primary" onClick={onSubmit}>
          Save
        </Button>
        <Button color="danger" className="ms-2" onClick={() => navigate(-1)}>
          Cancel
        </Button>
      </div>
    </Form>
  )
}

export default ColdCallForm
